export default "<fa-icon [icon]=\"icons[_icon]\"></fa-icon>\r\n";